import { render, staticRenderFns } from "./CandidateProfileTemplate.vue?vue&type=template&id=58bfc0ae&"
import script from "./CandidateProfileTemplate.vue?vue&type=script&lang=js&"
export * from "./CandidateProfileTemplate.vue?vue&type=script&lang=js&"
import style0 from "./CandidateProfileTemplate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VOverlay,VProgressCircular,VRow})
